import { gql } from "@apollo/client";

export const GET_LESSON_PAGINATION = gql`
  query GetLessonPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $keyword: String
    $classId: String
  ) {
    getLessonPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      keyword: $keyword
      classId: $classId
    ) {
      data {
        _id
        title
        numbering
        description
        videoLink
        image
        classId {
          _id
          className
          backgroundImage
        }
        groupFeeId {
          _id
          type
          title
          price
          remark
        }
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const CREATE_LESSON = gql`
  mutation CreateLesson($input: LessonInput) {
    createLesson(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_LESSON = gql`
  mutation UpdateLesson($id: ID!, $input: LessonInput) {
    updateLesson(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_LESSON = gql`
  mutation DeleteLesson($id: ID!) {
    deleteLesson(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;
